document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('a[href]');
  
  links.forEach(link => {
    const href = link.getAttribute('href');
    if (href && (href.startsWith('http://') || href.startsWith('https://'))) {
      const currentDomain = window.location.hostname;
      const linkDomain = new URL(href).hostname;
      
      if (linkDomain !== currentDomain) {
        link.classList.add('is-external');
        // Also add target="_blank" and rel="noopener" for security
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    }
  });
});